// Task #6709 — shared guard for Stripe Connect onboarding responses.
//
// `bookingsApi.createStripeConnectAccount` can return a 200 with no `url`
// (e.g. Stripe declined to mint an account link). Call sites used to pass
// the missing value straight into a redirect helper, so the button silently
// did nothing. Every call site must route the response through this helper
// so a missing link surfaces as a normal thrown error (and thus a toast in
// the caller's existing catch block), matching `startConnectOnboarding` on
// AccountPayoutsPage.
import i18n from "i18next";

export function requireStripeOnboardingUrl(response: { url?: string | null } | null | undefined): string {
  const url = response?.url;
  if (!url) {
    // Task #6727 — localized message; the English default keeps the copy
    // intact even if i18next hasn't initialized yet (defensive fallback).
    throw new Error(
      i18n.t("common.stripe_onboarding_link_missing", "Stripe didn't return an onboarding link. Please try again."),
    );
  }
  return url;
}
